import { motion } from "framer-motion";
import { Camera, BadgeDollarSign, Wrench } from "lucide-react";
import { useT } from "@/i18n_extra3";
import { scrollToId } from "@/utils";

const ICONS = [Camera, BadgeDollarSign, Wrench];

export const HowItWorks = () => {
  const t = useT();
  return (
    <section className="py-28 sm:py-32 bg-[#FAF9F6]" data-testid="how-it-works">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#B8860B]" />
            <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#B8860B]">{t.how.label}</span>
          </div>
          <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05] text-[#111111]">{t.how.title}</h2>
        </motion.div>

        <div className="relative mt-16 grid md:grid-cols-3 gap-10 md:gap-8">
          <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
            className="hidden md:block absolute top-[52px] left-[18%] right-[18%] h-px bg-gradient-to-r from-[#D4AF37]/10 via-[#D4AF37] to-[#D4AF37]/10 origin-left"
          />
          {t.how.steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.button
                key={s.t}
                onClick={() => scrollToId("#quote")}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.18 }}
                className="group relative text-left"
                data-testid={`how-step-${i + 1}`}
              >
                <div className="flex items-center gap-4">
                  <span className="relative z-10 w-[104px] h-[104px] rounded-full bg-[#FAF9F6] border border-[#D4AF37]/50 flex items-center justify-center group-hover:bg-[#D4AF37] group-hover:border-[#D4AF37] transition-colors duration-500 shrink-0">
                    <Icon className="w-9 h-9 text-[#B8860B] group-hover:text-black transition-colors duration-500" />
                  </span>
                  <span className="font-display font-bold text-6xl text-outline-ink leading-none">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <h3 className="mt-6 font-display font-semibold text-2xl text-[#111111] tracking-tight group-hover:text-[#B8860B] transition-colors duration-300">{s.t}</h3>
                <p className="mt-3 text-black/55 leading-relaxed max-w-xs">{s.d}</p>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
